import gql from "graphql-tag";

export const AssetMinimalFieldsFragment = gql`
    fragment AssetMinimalFieldsFragment on Asset {
        url
        title
    }
`;